import { render, staticRenderFns } from "./BoBmi.vue?vue&type=template&id=584ae36a&"
import script from "./BoBmi.vue?vue&type=script&lang=js&"
export * from "./BoBmi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports